import React from "react";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import CurrencyInput from "../../Components/CurrencyInput/CurrencyInput";
import { isValidUrl, uuid } from "../../Utils/Utils";
import { pdf } from "../../Images";
import { useSelector } from "react-redux";

const ProductDetailInformation = ({
  productDetail,
  onDetailChangeText,
  productColors,
  productTags,
  onFileChange,
  onRemoveFile,
  onChangeSwitch,
  onDetailReset,
  onDetailSave,
  approval_status,
  next_step_nik_detail,
}) => {
  let { userInfo } = useSelector((state) => state.auth);
  return (
    <>
      <div style={{ padding: "0 0.5rem" }}>
        <h5
          style={{
            marginTop: "1rem",
            marginBottom: "1.1rem",
            fontWeight: "200",
            borderBottom: "1px solid black",
            paddingBottom: "0.3rem",
          }}
        >
          Product Profile
        </h5>
        <div className="row">
          <div className="col-md-4" style={{ paddingRight: "1rem" }}>
            <div className="form-group">
              <label htmlFor="title">
                Title <span style={{ color: "red" }}>*</span>
              </label>
              <input
                style={{ resize: "none", whiteSpace: "pre-wrap" }}
                id="title"
                name="title"
                className="form-control"
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                onChange={onDetailChangeText}
                value={productDetail.title}
              />
            </div>
            <div className="form-group">
              <label htmlFor="header_description">
                Header Description <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                style={{ resize: "none", whiteSpace: "pre-wrap" }}
                id="header_description"
                name="header_description"
                className="form-control"
                rows={3}
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                onChange={onDetailChangeText}
                value={productDetail.header_description}
              />
            </div>
            <div className="form-group">
              <label htmlFor="feature">
                Feature <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                style={{ resize: "none", whiteSpace: "pre-wrap" }}
                id="feature"
                name="feature"
                className="form-control"
                rows={3}
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                onChange={onDetailChangeText}
                value={productDetail.feature}
              />
            </div>
            <div className="form-group">
              <label>
                Product Color <span style={{ color: "red" }}>*</span>
              </label>
              <div className="d-flex justify-content-between">
                <select
                  id="id_color"
                  name="id_color"
                  className="form-control mr-2"
                  onChange={onDetailChangeText}
                  value={productDetail.id_color}
                  disabled={
                    productDetail.language_code &&
                    (approval_status == "ONPROGRESS" ||
                      (approval_status == "ONREVISED" &&
                        next_step_nik_detail != userInfo.nik))
                  }
                >
                  <option value={""}>Select Color</option>
                  {productColors.map((item, i) => (
                    <option key={"color-" + i} value={item.id_color}>
                      {item.color}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="tagline">
                Tagline <span style={{ color: "red" }}>*</span>
              </label>
              <input
                id="tagline"
                name="tagline"
                className="form-control"
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                onChange={onDetailChangeText}
                value={productDetail.tagline}
              />
            </div>
            <div className="form-group">
              <label htmlFor="header_description">
                Description <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                style={{ resize: "none", whiteSpace: "pre-wrap" }}
                id="description"
                name="description"
                className="form-control"
                rows={3}
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                onChange={onDetailChangeText}
                value={productDetail.description}
              />
            </div>
            <div className="form-group">
              <label htmlFor="including">
                Including <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                style={{ resize: "none", whiteSpace: "pre-wrap" }}
                id="including"
                name="including"
                className="form-control"
                rows={3}
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                onChange={onDetailChangeText}
                value={productDetail.including}
              />
            </div>
            <div className="form-group">
              <label>
                Product Tag <span style={{ color: "red" }}>*</span>
              </label>
              <div className="d-flex justify-content-between">
                <select
                  id="id_tag"
                  name="id_tag"
                  className="form-control mr-2"
                  onChange={onDetailChangeText}
                  value={productDetail.id_tag}
                  disabled={
                    productDetail.language_code &&
                    (approval_status == "ONPROGRESS" ||
                      (approval_status == "ONREVISED" &&
                        next_step_nik_detail != userInfo.nik))
                  }
                >
                  <option value={""}>Select Tag</option>
                  {productTags.map((item, i) => (
                    <option key={"tag-" + i} value={item.id_tag}>
                      {item.title}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="price">
                Price <span style={{ color: "red" }}>*</span>
              </label>
              <CurrencyInput
                id="price"
                name="price"
                className="form-control"
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                onKeyUp={onDetailChangeText}
                value={productDetail.price}
                placeholder="Rp0"
              />
            </div>
            <div className="form-group">
              <label htmlFor="manual_book">Manual Book</label>
              <br />
              {(!productDetail.manual_book ||
                productDetail.manual_book == "null") && (
                  <>
                    <input
                      key={uuid()}
                      id="file-book"
                      className="d-none"
                      type="file"
                      accept="application/pdf"
                      onChange={onFileChange}
                      multiple={true}
                      disabled={
                        productDetail.language_code &&
                        (approval_status == "ONPROGRESS" ||
                          (approval_status == "ONREVISED" &&
                            next_step_nik_detail != userInfo.nik))
                      }
                    />
                    <button
                      type="button"
                      disabled={
                        productDetail.language_code &&
                        (approval_status == "ONPROGRESS" ||
                          (approval_status == "ONREVISED" &&
                            next_step_nik_detail != userInfo.nik))
                      }
                      className="btn btn-pmc"
                      style={{ width: 120 }}
                      onClick={() => {
                        window.$("#file-book").click();
                      }}
                    >
                      <i className="fa fa-image" /> Choose{" "}
                    </button>
                  </>
                )}

              {productDetail.manual_book &&
                productDetail.manual_book != "null" && (
                  <div
                    className="mt-2"
                    style={{ display: "flex", flexDirection: "row" }}
                  >
                    <div style={{ position: "relative" }}>
                      <img
                        src={pdf}
                        style={{
                          objectFit: "contain",
                          width: "100px",
                          height: "100px",
                          cursor: "pointer",
                        }}
                      />
                      <div
                        style={{ position: "absolute", bottom: 10, right: -10 }}
                      >
                        <Button
                          disabled={
                            productDetail.language_code &&
                            (approval_status == "ONPROGRESS" ||
                              (approval_status == "ONREVISED" &&
                                next_step_nik_detail != userInfo.nik))
                          }
                          type="button"
                          className="p-button-rounded p-button-danger"
                          icon="pi pi-times"
                          style={{ width: 30, height: 30 }}
                          onClick={() =>
                            onRemoveFile(productDetail.manual_book)
                          }
                        />
                      </div>
                    </div>

                    <div>
                      <p className="text-bold">File Name</p>
                      <p style={{ marginTop: "-20px" }}>
                        {productDetail.manual_book}
                      </p>
                      {isValidUrl(productDetail.manual_book) && (
                        <a
                          href={productDetail.manual_book}
                          target="_blank"
                          download
                          className="btn btn-warning btn-md ml-3"
                          style={{ width: "30%" }}
                        >
                          Download
                        </a>
                      )}
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
      <div style={{ padding: "0 0.5rem" }}>
        <h5
          style={{
            marginTop: "1rem",
            marginBottom: "1.1rem",
            fontWeight: "200",
            borderBottom: "1px solid black",
            paddingBottom: "0.3rem",
          }}
        >
          Website & SEO Details
        </h5>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="including">SEO Title</label>
              <input
                id="seo_title"
                name="seo_title"
                className="form-control"
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                onChange={onDetailChangeText}
                value={productDetail.seo_title}
              />
            </div>
            <div className="form-group">
              <label htmlFor="including">SEO Description</label>
              <textarea
                style={{ resize: "none", whiteSpace: "pre-wrap" }}
                id="seo_description"
                name="seo_description"
                className="form-control"
                rows={3}
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                onChange={onDetailChangeText}
                value={productDetail.seo_description}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="including">
                Product Display Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                id="product_display_name"
                name="product_display_name"
                className="form-control"
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                required
                onChange={onDetailChangeText}
                value={productDetail.product_display_name}
              />
            </div>

            <div className="form-group">
              <label htmlFor="including">URL AR</label>
              <input
                id="url_ar"
                name="url_ar"
                className="form-control"
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                onChange={onDetailChangeText}
                value={productDetail.url_ar}
              />
            </div>
          </div>
        </div>
      </div>
      <div style={{ padding: "0 0.5rem" }}>
        <h5
          style={{
            marginTop: "1rem",
            marginBottom: "1.1rem",
            fontWeight: "200",
            borderBottom: "1px solid black",
            paddingBottom: "0.3rem",
          }}
        >
          Me By MODENA
        </h5>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="sku_me_by_modena" style={{ fontWeight: "700" }}>
                SKU Sticker Me By MODENA
              </label>
              <input
                id="sku_me_by_modena"
                name="sku_me_by_modena"
                className="form-control"
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                onChange={onDetailChangeText}
                value={
                  productDetail.sku_me_by_modena != "null" &&
                    productDetail.sku_me_by_modena != "undefined"
                    ? productDetail.sku_me_by_modena
                    : ""
                }
              />
            </div>
            <div className="form-group">
              <label htmlFor="is_me_by_modena">Me By MODENA</label>
              <br />
              <div className="ml-2 mr-2">
                <InputSwitch
                  disabled={
                    productDetail.language_code &&
                    (approval_status == "ONPROGRESS" ||
                      (approval_status == "ONREVISED" &&
                        next_step_nik_detail != userInfo.nik))
                  }
                  checked={(productDetail.is_me_by_modena == "1" ? true : false)}
                  onChange={(e) => onChangeSwitch("is_me_by_modena", e.value)}
                />
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="sticker_price" style={{ fontWeight: "700" }}>
                Me By MODENA Sticker Price
              </label>
              <input
                id="sticker_price"
                name="sticker_price"
                className="form-control"
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                onChange={onDetailChangeText}
                value={productDetail.sticker_price}
              />
            </div>
          </div>
        </div>
      </div>
      <div style={{ padding: "0 0.5rem" }}>
        <h5
          style={{
            marginTop: "1rem",
            marginBottom: "1.1rem",
            fontWeight: "200",
            borderBottom: "1px solid black",
            paddingBottom: "0.3rem",
          }}
        >
          Product Status
        </h5>
        <div className="form-group d-flex">
          <label htmlFor="is_preorder">Preorder</label>
          <div className="ml-2 mr-2">
            <InputSwitch
              disabled={
                productDetail.language_code &&
                (approval_status == "ONPROGRESS" ||
                  (approval_status == "ONREVISED" &&
                    next_step_nik_detail != userInfo.nik))
              }
              checked={
                (productDetail.is_preorder == "true" ||
                  productDetail.is_preorder === true ||
                  productDetail.is_preorder == "1") &&
                productDetail.is_preorder != "false" &&
                productDetail.is_preorder != "0"
              }
              onChange={(e) => onChangeSwitch("is_preorder", e.value)}
            />
          </div>

          <label htmlFor="is_rental">Rental</label>
          <div className="ml-2 mr-2">
            <InputSwitch
              disabled={
                productDetail.language_code &&
                (approval_status == "ONPROGRESS" ||
                  (approval_status == "ONREVISED" &&
                    next_step_nik_detail != userInfo.nik))
              }
              checked={
                (productDetail.is_rental == "true" ||
                  productDetail.is_rental === true ||
                  productDetail.is_rental == "1") &&
                productDetail.is_rental != "false" &&
                productDetail.is_rental != "0"
              }
              onChange={(e) => onChangeSwitch("is_rental", e.value)}
            />
          </div>

          <label htmlFor="is_active">Active</label>
          <div className="ml-2 mr-2">
            <InputSwitch
              disabled={
                productDetail.language_code &&
                (approval_status == "ONPROGRESS" ||
                  (approval_status == "ONREVISED" &&
                    next_step_nik_detail != userInfo.nik))
              }
              checked={
                (productDetail.is_active == "true" ||
                  productDetail.is_active === true ||
                  productDetail.is_active == "1") &&
                productDetail.is_active != "false" &&
                productDetail.is_active != "0"
              }
              onChange={(e) => onChangeSwitch("is_active", e.value)}
            />
          </div>
        </div>
      </div>
      <div className="col-md-12">
        <div className="form-group">
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: 16,
            }}
          >
            <div style={{ width: 100, marginRight: 10 }}>
              <button
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                type="button"
                className="btn btn-block btn-danger"
                onClick={onDetailReset}
              >
                <i className="fa fa-times"></i> Clear
              </button>
            </div>
            <div style={{ width: 150 }}>
              <button
                disabled={
                  productDetail.language_code &&
                  (approval_status == "ONPROGRESS" ||
                    (approval_status == "ONREVISED" &&
                      next_step_nik_detail != userInfo.nik))
                }
                type="button"
                className="btn btn-block btn-dark"
                onClick={onDetailSave}
              >
                <i className="fa fa-save"></i> Draft
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDetailInformation;
